export default __webpack_public_path__ + "static/Jhonata-4a0a399a27f4cf04e709aa78acc8b00e.png";